//@ts-nocheck
import { Params } from "./params";
import { Project } from "./project";
import { BinaryReader, BinaryWriter } from "../../../binary";
import { isSet } from "../../../helpers";
import { GlobalDecoderRegistry } from "../../../registry";
function createBaseQueryParamsRequest() {
    return {};
}
export const QueryParamsRequest = {
    typeUrl: "/lavanet.lava.projects.QueryParamsRequest",
    is(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryParamsRequest.typeUrl;
    },
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    fromAmino(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsRequest.decode(message.value);
    },
    toProto(message) {
        return QueryParamsRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryParamsRequest",
            value: QueryParamsRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsRequest.typeUrl, QueryParamsRequest);
function createBaseQueryParamsResponse() {
    return {
        params: Params.fromPartial({})
    };
}
export const QueryParamsResponse = {
    typeUrl: "/lavanet.lava.projects.QueryParamsResponse",
    is(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.is(o.params));
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isSDK(o.params));
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryParamsResponse.typeUrl || Params.isAmino(o.params));
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            params: isSet(object.params) ? Params.fromJSON(object.params) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = Params.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.params = message.params ? Params.toAmino(message.params) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryParamsResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryParamsResponse.decode(message.value);
    },
    toProto(message) {
        return QueryParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryParamsResponse",
            value: QueryParamsResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryParamsResponse.typeUrl, QueryParamsResponse);
function createBaseQueryInfoRequest() {
    return {
        project: ""
    };
}
export const QueryInfoRequest = {
    typeUrl: "/lavanet.lava.projects.QueryInfoRequest",
    is(o) {
        return o && (o.$typeUrl === QueryInfoRequest.typeUrl || typeof o.project === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryInfoRequest.typeUrl || typeof o.project === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryInfoRequest.typeUrl || typeof o.project === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.project !== "") {
            writer.uint32(10).string(message.project);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInfoRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.project = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            project: isSet(object.project) ? String(object.project) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.project !== undefined && (obj.project = message.project);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryInfoRequest();
        message.project = object.project ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryInfoRequest();
        if (object.project !== undefined && object.project !== null) {
            message.project = object.project;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.project = message.project === "" ? undefined : message.project;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryInfoRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryInfoRequest.decode(message.value);
    },
    toProto(message) {
        return QueryInfoRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryInfoRequest",
            value: QueryInfoRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryInfoRequest.typeUrl, QueryInfoRequest);
function createBaseQueryInfoResponse() {
    return {
        project: undefined,
        pendingProject: undefined
    };
}
export const QueryInfoResponse = {
    typeUrl: "/lavanet.lava.projects.QueryInfoResponse",
    is(o) {
        return o && o.$typeUrl === QueryInfoResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryInfoResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryInfoResponse.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.project !== undefined) {
            Project.encode(message.project, writer.uint32(10).fork()).ldelim();
        }
        if (message.pendingProject !== undefined) {
            Project.encode(message.pendingProject, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryInfoResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.project = Project.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.pendingProject = Project.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            project: isSet(object.project) ? Project.fromJSON(object.project) : undefined,
            pendingProject: isSet(object.pendingProject) ? Project.fromJSON(object.pendingProject) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.project !== undefined && (obj.project = message.project ? Project.toJSON(message.project) : undefined);
        message.pendingProject !== undefined && (obj.pendingProject = message.pendingProject ? Project.toJSON(message.pendingProject) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryInfoResponse();
        message.project = object.project !== undefined && object.project !== null ? Project.fromPartial(object.project) : undefined;
        message.pendingProject = object.pendingProject !== undefined && object.pendingProject !== null ? Project.fromPartial(object.pendingProject) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryInfoResponse();
        if (object.project !== undefined && object.project !== null) {
            message.project = Project.fromAmino(object.project);
        }
        if (object.pending_project !== undefined && object.pending_project !== null) {
            message.pendingProject = Project.fromAmino(object.pending_project);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.project = message.project ? Project.toAmino(message.project) : undefined;
        obj.pending_project = message.pendingProject ? Project.toAmino(message.pendingProject) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryInfoResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryInfoResponse.decode(message.value);
    },
    toProto(message) {
        return QueryInfoResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryInfoResponse",
            value: QueryInfoResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryInfoResponse.typeUrl, QueryInfoResponse);
function createBaseQueryDeveloperRequest() {
    return {
        developer: ""
    };
}
export const QueryDeveloperRequest = {
    typeUrl: "/lavanet.lava.projects.QueryDeveloperRequest",
    is(o) {
        return o && (o.$typeUrl === QueryDeveloperRequest.typeUrl || typeof o.developer === "string");
    },
    isSDK(o) {
        return o && (o.$typeUrl === QueryDeveloperRequest.typeUrl || typeof o.developer === "string");
    },
    isAmino(o) {
        return o && (o.$typeUrl === QueryDeveloperRequest.typeUrl || typeof o.developer === "string");
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.developer !== "") {
            writer.uint32(10).string(message.developer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDeveloperRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.developer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            developer: isSet(object.developer) ? String(object.developer) : ""
        };
    },
    toJSON(message) {
        const obj = {};
        message.developer !== undefined && (obj.developer = message.developer);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDeveloperRequest();
        message.developer = object.developer ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryDeveloperRequest();
        if (object.developer !== undefined && object.developer !== null) {
            message.developer = object.developer;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.developer = message.developer === "" ? undefined : message.developer;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryDeveloperRequest.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryDeveloperRequest.decode(message.value);
    },
    toProto(message) {
        return QueryDeveloperRequest.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryDeveloperRequest",
            value: QueryDeveloperRequest.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryDeveloperRequest.typeUrl, QueryDeveloperRequest);
function createBaseQueryDeveloperResponse() {
    return {
        project: undefined,
        pendingProject: undefined
    };
}
export const QueryDeveloperResponse = {
    typeUrl: "/lavanet.lava.projects.QueryDeveloperResponse",
    is(o) {
        return o && o.$typeUrl === QueryDeveloperResponse.typeUrl;
    },
    isSDK(o) {
        return o && o.$typeUrl === QueryDeveloperResponse.typeUrl;
    },
    isAmino(o) {
        return o && o.$typeUrl === QueryDeveloperResponse.typeUrl;
    },
    encode(message, writer = BinaryWriter.create()) {
        if (message.project !== undefined) {
            Project.encode(message.project, writer.uint32(10).fork()).ldelim();
        }
        if (message.pendingProject !== undefined) {
            Project.encode(message.pendingProject, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDeveloperResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.project = Project.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.pendingProject = Project.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            project: isSet(object.project) ? Project.fromJSON(object.project) : undefined,
            pendingProject: isSet(object.pendingProject) ? Project.fromJSON(object.pendingProject) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.project !== undefined && (obj.project = message.project ? Project.toJSON(message.project) : undefined);
        message.pendingProject !== undefined && (obj.pendingProject = message.pendingProject ? Project.toJSON(message.pendingProject) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDeveloperResponse();
        message.project = object.project !== undefined && object.project !== null ? Project.fromPartial(object.project) : undefined;
        message.pendingProject = object.pendingProject !== undefined && object.pendingProject !== null ? Project.fromPartial(object.pendingProject) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseQueryDeveloperResponse();
        if (object.project !== undefined && object.project !== null) {
            message.project = Project.fromAmino(object.project);
        }
        if (object.pending_project !== undefined && object.pending_project !== null) {
            message.pendingProject = Project.fromAmino(object.pending_project);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.project = message.project ? Project.toAmino(message.project) : undefined;
        obj.pending_project = message.pendingProject ? Project.toAmino(message.pendingProject) : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return QueryDeveloperResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return QueryDeveloperResponse.decode(message.value);
    },
    toProto(message) {
        return QueryDeveloperResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/lavanet.lava.projects.QueryDeveloperResponse",
            value: QueryDeveloperResponse.encode(message).finish()
        };
    }
};
GlobalDecoderRegistry.register(QueryDeveloperResponse.typeUrl, QueryDeveloperResponse);
